/**
 * AutryParagraphVideo
 * Player or Playlist
 */

import * as short from 'short-uuid'

Drupal.behaviors.AutryParagraphVideo = {
  attach: function (context, settings) {
    const elements = once(
      'AutryParagraphVideo',
      '.paragraph-type--video',
      context
    )
    elements.forEach(el => {
      const player = el.querySelector('iframe')
      const caption = el.querySelector('figcaption p')
      const items = Array.from(el.querySelectorAll('a[data-embed]'))
      const uuid = 'autry-playlist--' + short.generate()

      player.setAttribute('id', uuid)

      items.forEach((thumb, n) => {
        if (n === 0) {
          thumb.setAttribute('aria-current', true)
        }
        // add accessible attributes to playlist links
        thumb.setAttribute('aria-controls', uuid)
        thumb.setAttribute('aria-label', 'play this video')

        thumb.addEventListener('click', e => {
          e.preventDefault()
          // update the video source & caption
          player.setAttribute('src', thumb.getAttribute('data-embed'))
          caption.textContent = thumb.getAttribute('title')

          // move aria-current to the clicked thumbnail
          const selected = el.querySelector('a[data-embed][aria-current]')
          if (selected) {
            selected.removeAttribute('aria-current')
          }
          thumb.setAttribute('aria-current', true)
        })
      })
    })
  }
}
